module.exports = __webpack_public_path__ + "img/2_233.1c2f5c4b.png";